import { message } from 'antd'
import _, { get,set } from 'lodash'

// 自有品牌需要填写的资质列表
const selfBrandQuaArr = ['商标注册证', '品牌授权书（授权视客）']
export const getSavedBrandQua = (brands, paramData) => {
  var _cloneData = _.cloneDeep(get(paramData, 'brand_list'))
  var olds = (_cloneData.map(item => get(item, 'brand_id') + '/' + get(item, 'brand_name'))) || []
  //剔除非新建且删除的品牌
  _cloneData = _.filter(_cloneData,function(brand){return !get(brand, 'brand_id')||get(brand, 'brand_id')&&brands.includes(get(brand, 'brand_id') + '/' + get(brand, 'brand_name'))})
  //拿出新加的已有品牌
  var newBrands =_.filter(brands,function(brand){return !olds.includes(brand)})
  var newBrandQuas = newBrands.map((brand) => {
    var brand_id = brand.split('/')[0]
    var brand_name = brand.split('/')[1]
    return {
      brand_id,
      brand_idd: brand_id,//假brand_id
      brand_role: 1,
      brand_name,
      brand_qualification_list: selfBrandQuaArr.map((item, index) => { return { 'qua_name': item, 'sort': index === 0 ? 1 : 3, files: [] } }),
    }
  })
  //全部品牌：新加已有品牌+（已添加-已删除）
  return handleBrandQua([...newBrandQuas,..._cloneData])
}

export const handleBrandQua = (brand_list) => {
  brand_list.forEach(item => {
    var role = get(item, 'brand_role');
    if (role == 1) {
      // 自有品牌：商标注册证 + 品牌授权书（授权视客）
      var hasTradeCert = _.find(item.brand_qualification_list, { qua_name: '商标注册证' });
      var hasAuthDoc = _.find(item.brand_qualification_list, { qua_name: '品牌授权书（授权视客）' });
      var newList = [];
      if (hasTradeCert) {
        newList.push(hasTradeCert);
      } else {
        newList.push({ qua_name: '商标注册证', sort: 1, files: [], fileListNew: [] });
      }
      if (hasAuthDoc) {
        newList.push(hasAuthDoc);
      } else {
        newList.push({ qua_name: '品牌授权书（授权视客）', sort: 3, files: [], fileListNew: [] });
      }
      item.brand_qualification_list = newList;
    } else if (role == 2) {
      // 代理品牌：不需要填写资质
      item.brand_qualification_list = [];
    }
  });
  return brand_list;
};

export const getBrandQuaItem = (brand) => {
  return { ...brand, brand_role: 1, brand_qualification_list: selfBrandQuaArr.map((item, index) => { return { 'qua_name': item, 'sort': index === 0 ? 1 : 3, files: [] } }), }
}

export const brandInformationDataConversion = (paramData) => {
  if (paramData.brand_list.length !== 0) {
    paramData.brand_list.forEach((item) => {
      let isRequre = true
      if (item.brand_role === 1) {
        // 自有品牌：校验商标注册证和 品牌授权书（授权视客）
        if (get(item,'brand_qualification_list.length')!== 0) {
          get(item,'brand_qualification_list',[]).forEach((item2) => {
            if (item2.sort === 1) {
              // 商标注册证
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            } else if (item2.sort === 3) {
              // 品牌授权书（授权视客）
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          })
        }
      }
      // 代理品牌不需要填写，isRequre 保持 true
      set(item,'fillin',isRequre)
    })
  }
  return paramData
}

export const brandInformationDataJudgment = (paramData) => {
  if (paramData.brand_list.length !== 0) {
    for (let i = 0; i < paramData.brand_list.length; i++) {
      var item = paramData.brand_list[i]
      let isRequre = true
      if (item.brand_role === 1) {
        // 自有品牌：校验商标注册证和 品牌授权书（授权视客）
        if (get(item,'brand_qualification_list.length')!== 0) {
          get(item,'brand_qualification_list',[]).forEach((item2) => {
            if (item2.sort === 1) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0 || !item2.qua_code || !item2.brand_type || !item2.brand_register) {
                isRequre = false
              }
            } else if (item2.sort === 3) {
              if (!item2.begin_time || !item2.end_time || item2.files.length === 0) {
                isRequre = false
              }
            }
          })
        }
      }
      // 代理品牌不需要填写
      if (!isRequre) {
        message.error(item.brand_name + '必填项未填', 2)
        return false
      }
    }
  }
  return true
}


// WEBPACK FOOTER //
// ./src/pages/newsuppliersettlement/supplierinformationentry/brand/utils.js